<script>
  export let item;
</script>

<style>
  .skill {
    margin-bottom: 1rem;
  }
  .denominator {
    background-color: #ccc;
    border-radius: 20px;
    overflow: hidden;
    height: 1.5rem;
    display: flex;
  }
  .numerator {
    background-color: var(--color-theme-2);
    border-radius: 20px;
  }
</style>

<div class="row skill">
  <div class="col-12">{item.name}</div>
  <div class="col-12">
    <div class="denominator">
      <div class="numerator" style="width: {`${item.rating}%`}" />
    </div>
  </div>
</div>
